import styled from 'styled-components';
import { Collapse, Form, Space } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

export const HeaderTitle = styled.h2`
  font-size: 16px;
  font-weight: 600;
  margin: 0;
`;

export const StyledForm = styled(Form)`
  .gm-ant-form-item {
    margin-bottom: 0;
  }
` as typeof Form;

export const Content = styled(Collapse)`
  background: transparent;
  border-radius: 0;

  .gm-ant-collapse-header-text {
    font-weight: 600;
    line-height: 20px;
  }

  .gm-ant-collapse-content-box {
    padding-left: 40px !important;
  }

  .gm-ant-collapse-item:nth-of-type(1) {
    .gm-ant-collapse-content-box {
      padding-left: 10px !important;

      > button {
        margin-left: 30px;
      }
    }
  }
`;

export const TooltipInfoIcon = styled(InfoCircleOutlined)`
  color: #8c8c8c;
  margin-left: 4px;
`;

export const EmptyHint = styled.div`
  color: #8c8c8c;
  font-size: 12px;
`;

export const StepSpace = styled(Space)`
  > *:nth-of-type(2) {
    flex: 1;
  }

  button[data-draggable] {
    width: 26px;
  }

  button[data-step-label] {
    pointer-events: none;
    width: 82px;
  }

  button:not([data-draggable]) {
    background: #f5f5f5;
  }
` as typeof Space;

export const StepFormItem = styled(Form.Item)`
  .gm-ant-form-item-additional {
    padding-left: 36px;
  }
` as typeof Form.Item;
